import { Row } from 'antd';
import LangSwitch from 'app/components/LangSwitch/LangSwitch';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextRegular14 } from 'styles/typography';

import * as S from './AuthLayout.styles';

interface IProps {
  children: React.ReactChild;
}

const AuthLayout = ({ children }: IProps) => {
  const { t } = useTranslation();

  return (
    <>
      <S.LayoutWrapper>
        <Row justify="end">
          <LangSwitch />
        </Row>
        <S.LogoRow justify="center">
          <S.Logo />
          <S.LogoText />
        </S.LogoRow>
        <S.MainRow justify="center">{children}</S.MainRow>

        <Row justify="center">
          <TextRegular14>
            {t('Auth.FooterText', 'www.hiiko.eu | www.horiondigital.com')}
          </TextRegular14>
        </Row>
      </S.LayoutWrapper>
    </>
  );
};

export default AuthLayout;
